/**
 * @generated SignedSource<<92b92c87a97530bc1099199ab9a2d225>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VotableOrder = "HOT" | "NEWEST" | "OLDEST";
export type TopicCommentsFragmentPaginationQuery$variables = {
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  id: string;
  order?: VotableOrder | null | undefined;
};
export type TopicCommentsFragmentPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"TopicCommentsFragment">;
  };
};
export type TopicCommentsFragmentPaginationQuery = {
  response: TopicCommentsFragmentPaginationQuery$data;
  variables: TopicCommentsFragmentPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": "HOT",
  "kind": "LocalArgument",
  "name": "order"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "kind": "Variable",
  "name": "order",
  "variableName": "order"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v5/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hotness",
  "storageKey": null
},
v11 = {
  "alias": "viewerCanDelete",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "DELETE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"DELETE_COMMENT\")"
},
v12 = {
  "alias": "viewerCanUpdate",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "UPDATE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_COMMENT\")"
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "edited",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topic",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Forum",
      "kind": "LinkedField",
      "name": "forum",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v7/*: any*/)
          ],
          "storageKey": null
        },
        (v7/*: any*/)
      ],
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v18/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v19/*: any*/),
        (v20/*: any*/)
      ],
      "type": "Entity",
      "abstractKey": "__isEntity"
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": "viewerCanReply",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_COMMENT\")"
},
v23 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v24 = [
  (v23/*: any*/),
  (v5/*: any*/)
],
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voterCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v23/*: any*/)
      ],
      "concreteType": "VotersConnection",
      "kind": "LinkedField",
      "name": "voters",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EntityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                (v18/*: any*/),
                {
                  "kind": "TypeDiscriminator",
                  "abstractKey": "__isEntity"
                },
                (v19/*: any*/),
                (v20/*: any*/),
                (v7/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "voters(first:10)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EntityVote",
      "kind": "LinkedField",
      "name": "voted",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "score",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "viewerCanVote",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "PUBLISH_VOTE"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"PUBLISH_VOTE\")"
    }
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v28 = [
  "order"
],
v29 = {
  "alias": null,
  "args": (v24/*: any*/),
  "filters": (v28/*: any*/),
  "handle": "connection",
  "key": "CommentCommentsFragment_children",
  "kind": "LinkedHandle",
  "name": "children"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicCommentsFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v5/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "TopicCommentsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "TopicCommentsFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "CommentConnection",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": (v24/*: any*/),
                            "concreteType": "CommentConnection",
                            "kind": "LinkedField",
                            "name": "children",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CommentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/),
                                      (v21/*: any*/),
                                      (v22/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v24/*: any*/),
                                        "concreteType": "CommentConnection",
                                        "kind": "LinkedField",
                                        "name": "children",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CommentEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              (v9/*: any*/),
                                              (v10/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Comment",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v7/*: any*/),
                                                  (v11/*: any*/),
                                                  (v12/*: any*/),
                                                  (v13/*: any*/),
                                                  (v14/*: any*/),
                                                  (v15/*: any*/),
                                                  (v16/*: any*/),
                                                  (v17/*: any*/),
                                                  (v21/*: any*/),
                                                  (v22/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": (v24/*: any*/),
                                                    "concreteType": "CommentConnection",
                                                    "kind": "LinkedField",
                                                    "name": "children",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "CommentEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          (v9/*: any*/),
                                                          (v10/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Comment",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v7/*: any*/),
                                                              (v11/*: any*/),
                                                              (v12/*: any*/),
                                                              (v13/*: any*/),
                                                              (v14/*: any*/),
                                                              (v15/*: any*/),
                                                              (v16/*: any*/),
                                                              (v17/*: any*/),
                                                              (v21/*: any*/),
                                                              (v22/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": (v24/*: any*/),
                                                                "concreteType": "CommentConnection",
                                                                "kind": "LinkedField",
                                                                "name": "children",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CommentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      (v9/*: any*/),
                                                                      (v10/*: any*/),
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "Comment",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v7/*: any*/),
                                                                          (v11/*: any*/),
                                                                          (v12/*: any*/),
                                                                          (v13/*: any*/),
                                                                          (v14/*: any*/),
                                                                          (v15/*: any*/),
                                                                          (v16/*: any*/),
                                                                          (v17/*: any*/),
                                                                          (v21/*: any*/),
                                                                          (v22/*: any*/),
                                                                          {
                                                                            "alias": null,
                                                                            "args": (v24/*: any*/),
                                                                            "concreteType": "CommentConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "children",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "CommentEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                  (v9/*: any*/),
                                                                                  (v10/*: any*/),
                                                                                  {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Comment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                      (v7/*: any*/),
                                                                                      (v11/*: any*/),
                                                                                      (v12/*: any*/),
                                                                                      (v13/*: any*/),
                                                                                      (v14/*: any*/),
                                                                                      (v15/*: any*/),
                                                                                      (v16/*: any*/),
                                                                                      (v17/*: any*/),
                                                                                      (v21/*: any*/),
                                                                                      (v22/*: any*/),
                                                                                      {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "kind": "ScalarField",
                                                                                        "name": "numChildren",
                                                                                        "storageKey": null
                                                                                      },
                                                                                      (v6/*: any*/),
                                                                                      (v25/*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                  }
                                                                                ],
                                                                                "storageKey": null
                                                                              },
                                                                              (v26/*: any*/),
                                                                              (v27/*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                          },
                                                                          (v29/*: any*/),
                                                                          (v6/*: any*/),
                                                                          (v25/*: any*/)
                                                                        ],
                                                                        "storageKey": null
                                                                      }
                                                                    ],
                                                                    "storageKey": null
                                                                  },
                                                                  (v26/*: any*/),
                                                                  (v27/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v29/*: any*/),
                                                              (v6/*: any*/),
                                                              (v25/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v26/*: any*/),
                                                      (v27/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v29/*: any*/),
                                                  (v6/*: any*/),
                                                  (v25/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v26/*: any*/),
                                          (v27/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v29/*: any*/),
                                      (v6/*: any*/),
                                      (v25/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v26/*: any*/),
                              (v27/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v29/*: any*/),
                          (v6/*: any*/),
                          (v25/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  (v27/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "filters": (v28/*: any*/),
                "handle": "connection",
                "key": "TopicCommentsFragment_comments",
                "kind": "LinkedHandle",
                "name": "comments"
              }
            ],
            "type": "Topic",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3757d9094805635b041c7b90a91b7502",
    "id": null,
    "metadata": {},
    "name": "TopicCommentsFragmentPaginationQuery",
    "operationKind": "query",
    "text": "query TopicCommentsFragmentPaginationQuery(\n  $count: Int = 10\n  $cursor: String\n  $order: VotableOrder = HOT\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...TopicCommentsFragment_2kH0K8\n    id\n  }\n}\n\nfragment CommentCommentsFragment_1CbDfQ on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_3zZj4p\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_28oB9U on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_4kTGy2\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_3zZj4p on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_4hzBTb\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_4hzBTb on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_2rOHm3\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_4kTGy2 on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_1CbDfQ\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentDeleteFragment on Comment {\n  id\n  author {\n    id\n  }\n  topic {\n    id\n  }\n  parent {\n    id\n  }\n}\n\nfragment CommentDisplayFragment on Comment {\n  viewerCanDelete: viewerCan(action: DELETE_COMMENT)\n  viewerCanUpdate: viewerCan(action: UPDATE_COMMENT)\n  id\n  content\n  edited\n  createdAt\n  topic {\n    forum {\n      owner {\n        __typename\n        id\n      }\n      id\n    }\n    id\n  }\n  parent {\n    id\n  }\n  ...CommentDeleteFragment\n  author {\n    id\n    username\n    ...EntityProfilePicFragment_49kWkb\n  }\n  ...VoteDisplayFragment\n}\n\nfragment CommentFragment_1CbDfQ on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_1CbDfQ\n}\n\nfragment CommentFragment_28oB9U on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_28oB9U\n}\n\nfragment CommentFragment_2rOHm3 on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  numChildren\n}\n\nfragment CommentFragment_3zZj4p on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_3zZj4p\n}\n\nfragment CommentFragment_4hzBTb on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_4hzBTb\n}\n\nfragment CommentFragment_4kTGy2 on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_4kTGy2\n}\n\nfragment CommentReplyFragment on Comment {\n  id\n  viewerCanReply: viewerCan(action: CREATE_COMMENT)\n  topic {\n    forum {\n      owner {\n        __typename\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment EntitiesAvatarFragment on VotersConnection {\n  edges {\n    node {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment TopicCommentsFragment_2kH0K8 on Topic {\n  comments(first: $count, after: $cursor, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_28oB9U\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment VoteDisplayFragment on Votable {\n  __isVotable: __typename\n  id\n  votes\n  voterCount\n  voters(first: 10) {\n    ...EntitiesAvatarFragment\n  }\n  voted @ifAllowed {\n    score\n  }\n  viewerCanVote: viewerCan(action: PUBLISH_VOTE)\n}\n"
  }
};
})();

(node as any).hash = "fa4150a618f26a8294e1c5b2acd20b2f";

export default node;
